import React, { Component } from "react";
import { ButtonWrapper } from "./Button.style";

export default class Button extends Component {
  render() {
    const { text, onClick, styles = {} } = this.props;
    const { wrapper } = styles;
    const color = this.props.color ? this.props.color: "green";
    return (
      <ButtonWrapper
       width = {this.props.width}
        color={color}
        onClick={onClick}
        style={wrapper ? { ...wrapper } : {}}
        {...this.props.style}
      >
        {text}
      </ButtonWrapper>
    );
  }
}
